<!--补扣记录-->
<template>
	<div class="operateRecord custom-scrollbar">
		<div class="page_top_form">
			<el-form ref="form" label-width="90px">
				<el-form-item label="记录日期">
					<el-date-picker v-model="dataTime" type="date" placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="补扣对象">
					<el-input v-model="userName" placeholder="请输入业主名称" style="width:140px"></el-input>
				</el-form-item>
				<el-form-item label="">
					<el-button type="primary" size="mini" @click="search">查询</el-button>
					<el-button type="primary" size="mini" @click="exportReport">批量导出</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="recordList">
			<el-table :data="dataList" height="795" border style="width: 100%" v-loading="loading">
				<el-table-column type="index" width="50">
				</el-table-column>
				<el-table-column prop="operatorName" label="操作员">
				</el-table-column>
				<el-table-column prop="moneyOne" label="补扣前余额（元）">
				</el-table-column>
				<el-table-column prop="money" label="补扣金额（元）">
				</el-table-column>
				<el-table-column prop="moneyTwo" label="补扣后余额（元）">
				</el-table-column>
				<el-table-column prop="userName" label="补扣对象">
				</el-table-column>
				<el-table-column prop="descrip" label="补扣原因">
				</el-table-column>
				<el-table-column prop="createTime" label="补扣时间" :formatter="dataTimeFormatter">
				</el-table-column>
			</el-table>
		</div>
		<elPagination :total="total" :pageSize="pageSize" @pageindexChange="pageindexChange" @handleSizeChange="handleSizeChange" />
		<RefundDialog ref="refundDialog"></RefundDialog>
	</div>
</template>

<script>
	import datePicker from '@/components/module/universal/datePicker.vue'
	import singleSelection from '@/components/module/selection/singleSelection.vue'
	import infoListMultipleSelection from './infoListMultipleSelection.vue'
	import RefundDialog from './dialogs/RefundDialog.vue'
	import elPagination from "@/components/module/elComponents/elPagination.vue"
	export default {
		components: {
			datePicker,
			singleSelection,
			infoListMultipleSelection,
			RefundDialog,
			elPagination
		},
		props: {},
		data() {
			return {
				dataList: [],
				pageIndex: 1,
				pageSize: 20,
				total: 0,
				dataTime: '',
				filterTime: false,
				searchChange: false,
				userName:"",
				loading:false,
			}
		},
		created() {},
		mounted() {
			this.search()
		},
		destroyed() {},
		computed: {
			nowUser() {
				return this.$store.userStore.state.nowUserInfo
			},
			nowUnit() {
				return this.$store.unitStore.state.nowUnit
			},
			nowSelectDate() {
				return this.$store.cacheStore.getters.getNowSelectDate
			},
			nowTimeInterval() {
				return this.$store.cacheStore.getters.getOperateRecordsTimeInterval
			},
		},
		watch: {},
		methods: {
			//当前页
			pageindexChange(val) {
				this.pageIndex = val;
				this.search()
			},
			//页大小
			handleSizeChange(val) {
				this.pageSize = val;
				this.pageIndex = 1;
				this.search()
			},
			search() {
				var beginTime =''
				var endTime =''
				if(!isempty(this.dataTime)){
					let dataTime=new Date(this.dataTime).format('yyyy-MM-dd')
					beginTime=new Date(dataTime+' 00:00:00').getTime()
					endTime=new Date(dataTime+' 23:59:59').getTime()
				}
				this.loading=true
				this.$api.noticeApi.getCBMPLimit(this.nowUnit.id, this.pageIndex, this.pageSize, beginTime, endTime,this.userName, respon => {
					this.dataList = this.moneyFormatter(copy(respon.data.content));
					this.total = respon.data.totalElements
					this.loading=false
				}, err => {
					this.loading=false
					this.$message.error(err);
				})
			},
			// 批量导出
			exportReport() {
				var beginTime = this.filterTime ? this.nowTimeInterval.startDate.getTime() : undefined
				var endTime = this.filterTime ? this.nowTimeInterval.endDate.getTime() : undefined
				var title = this.nowUnit.name + '补扣记录信息'
				this.$store.cacheStore.state.load=true
				this.$api.noticeApi.exportUnitMakeUp(this.nowUnit.id,beginTime, endTime,this.userName, respon => {
					this.$store.cacheStore.state.load=false
					saveAs(DWSystemSetting.downloadUrl + '/' + respon, title + ".xls")
				}, err => {
					this.$store.cacheStore.state.load=false
					this.$dialogMethod.showMessage(err)
				})
			},

			dataTimeFormatter(row,column){
				//格式化日期
				return new Date(row.createTime).format("yyyy-MM-dd hh:mm:ss")
			},
			moneyFormatter(e){
				e.forEach(function (item) {
					item.moneyOne = (item.moneyOne/100).toFixed(2);
					item.moneyTwo = (item.moneyTwo/100).toFixed(2);
					if((item.moneyTwo-item.moneyOne)>0){
						item.money = "+"+(item.money/100).toFixed(2);
					}else{
						item.money = "-"+(item.money/100).toFixed(2);
					}
				})
				return e;
			}
		}
	}
</script>

<style scoped>
	.operateRecord {
		height: 100%;
		background-color: #FFFFFF;
	}

	.searchContainer {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding-top: 10px;
	}

	.searchContainer>div {
		flex-grow: 0;
		display: inline-flex;
	}

	.searchContainer label {
		line-height: 36px;
		margin-right: 6px;
	}

	.searchContainer input {
		border-color: #DCDFE6;
		width: 150px;
		height: 36px;
		box-sizing: border-box;
		margin-right: 20px;
	}

	.searchContainer>>>.selection-body {
		display: inline-flex;
		padding: 0;
		margin-right: 20px;
	}

	.searchContainer>>>.selection>p {
		line-height: 32px;
		height: 32px;
	}

	.searchContainer>button {
		height: 36px;
		background-color: #409EFF;
		color: #FFFFFF;
		padding: 0 18px;
		margin-left: 10px;
		border-radius: 4px;
		flex-shrink: 0;
		cursor: pointer;
	}

	.selectDateTime {
		display: inline-flex;
		justify-content: space-between;
		align-items: center;
		width: 176px;
		height: 34px;
		padding: 0 6px;
		background: #FFFFFF;
		border-radius: 6px;
		border: solid 1px silver;
		margin-right: 20px;
	}

	.selectDateTime>span {
		width: 140px;
		line-height: 34px;
		height: 100%;
		cursor: pointer;
	}

	.selectDateTime>img {
		width: 24px;
		height: 24px;
		cursor: pointer;
	}

	.recordList {
		padding: 0 20px;
	}

	.operateBtn {
		display: inline-block;
		border-radius: 4px;
		line-height: 28px;
		padding: 0 6px;
		background: #ECF5FF;
		color: #409EFF;
		border: solid 1px #409EFF;
		margin-right: 8px;
		cursor: pointer;
	}

	.operateBtnDisabled {
		display: inline-block;
		border-radius: 4px;
		line-height: 28px;
		padding: 0 6px;
		background: #ECF5FF;
		color: #409EFF;
		border: solid 1px #409EFF;
		margin-right: 8px;
		cursor: no-drop;
	}
</style>